import mobs from "./monsters.json";
class Formulas {
    static autoMinRawDamageCalc(stat, weaponAtk, base) {
      return (stat * weaponAtk) / 20 + base / 4;
    }
  
    static autoMaxRawDamageCalc(stat, weaponAtk, base) {
      return (stat * weaponAtk) / 10 + base / 4;
    }
  
    static specialMeldistMinRawDamageCalc(stat, weaponAtk, base) {
      return 1.5 * ((stat * weaponAtk) / 20 + (base / 4));
    }
  
    static specialMeldistMaxRawDamageCalc(stat, weaponAtk, base) {
      return 1.5 * ((stat * weaponAtk) / 10 + (base / 4));
    }

    static specialDist4arrowMinRawDamageCalc(stat, weaponAtk, base) {
      return 2.0 * ((stat * weaponAtk) / 20 + (base / 4));
    }

    static specialDist4arrowMaxRawDamageCalc(stat, weaponAtk, base) {
      return 2.0 * ((stat * weaponAtk) / 10 + (base / 4));
    }
  
    static specialMagicMinRawDamageCalc(stat, weaponAtk, base) {
      return 1.5 * ((1.05 * stat * weaponAtk) / 20 + (9 * base) / 32);
    }
  
    static specialMagicMaxRawDamageCalc(stat, weaponAtk, base) {
      return 1.5 * ((1.05 * stat * weaponAtk) / 10 + (9 * base) / 32);
    }
  
    static minDamageCalc(minRawDamage, mobDefense) {
      let minDamage = minRawDamage - mobDefense;
      if (minDamage < 0) {
        minDamage = 0;
      }
      return minDamage;
    }
  
    static maxDamageCalc(maxRawDamage, mobDefense) {
      return maxRawDamage - mobDefense;
    }
  
    static maxRawCritDamageCalc(maxRawDamage) {
      return maxRawDamage * 1.05;
    }
  
    static maxCritDamageCalc(maxRawCritDamage, mobDefense) {
      return maxRawCritDamage - mobDefense;
    }
  
    static normalAccuracyCalc(maxRawDamage, minRawDamage, x) {
      let normalAccuracy = (maxRawDamage - x) / (maxRawDamage - minRawDamage);
      if (normalAccuracy > 1.0) {
        normalAccuracy = 1.0;
      }
      return normalAccuracy;
    }
  
    static critAccuracyCalc(maxRawCritDamage, maxRawDamage, x) {
      let critAccuracy = (maxRawCritDamage - x) / (maxRawCritDamage - maxRawDamage);
      if (critAccuracy > 1.0) {
        critAccuracy = 1.0;
      }
      return critAccuracy;
    }
  
   
    static accuracyCalc(maxRawCritDamage, maxRawDamage, minRawDamage, x) {
      if (maxRawDamage === minRawDamage) {
        // Handle the case where maxRawDamage and minRawDamage are equal
        return 0;
      }
    
      return (
        Formulas.normalAccuracyCalc(maxRawDamage, minRawDamage, x) * 0.99 +
        Formulas.critAccuracyCalc(maxRawCritDamage, maxRawDamage, x) * 0.01
      );
    }
    
  
    static totalAccuracyCalc(accuracy, tick) {
      return 1.0 - Math.pow(Math.pow(1.0 - accuracy, tick), 10);
    }
  
    static timeToKillCalc(avgdmg, pos) {
      return mobs[pos].hp / avgdmg;
    }
  
    static averageDamageCalc(accuracy, maxDamage, minDamage, maxCritDamage) {
      return (
        accuracy * (0.99 * (maxDamage + minDamage) / 2) +
        0.01 * (maxCritDamage + maxDamage) / 2
      );
    }
  
    static tickrateCalc(accuracy, maxtickrate) {
      return maxtickrate * (1.0 - Math.pow(1.0 - accuracy, 10.0));
    }
  
    static powerTickrateCalc(totalaccuracy, maxtickrate) {
      return maxtickrate * totalaccuracy;
    }
  
    static maxTickrateCalc(tick) {
      if (tick <= 5) {
        return tick * 3600;
      } else {
        return 18000;
      }
    }
  
    static expCalc(base) {
      return Math.pow(base, base / 1000 + 3);
    }
  
    static stat0to54Calc(stat) {
      return Math.pow(stat, stat / 1000 + 2.373);
    }
  
    static stat55to99Calc(stat) {
      return Math.pow(stat, stat / 1000 + 2.171);
    }
    static offlineticks(stat) {
      if (stat <= 54) {
        return Math.pow(stat, stat / 1000 + 2.373);
      } else {
        return Math.pow(stat, stat / 1000 + 2.171);
      }
    }
    
  
    static findStatLevelCalc(ticks2) {
      if (ticks2 <= Formulas.stat0to54Calc(54)) {
        for (let stat = 5; stat <= 54; stat++) {
          if (ticks2 <= Formulas.stat0to54Calc(stat)) {
            const fract =
              (ticks2 - Formulas.stat0to54Calc(stat - 1)) /
              (Formulas.stat0to54Calc(stat) - Formulas.stat0to54Calc(stat - 1));
            return stat - 1 + fract;
          }
        }
      } else {
        for (let stat = 55; stat <= 1000; stat++) {
          if (ticks2 <= Formulas.stat55to99Calc(stat)) {
            const fract =
              (ticks2 - Formulas.stat55to99Calc(stat - 1)) /
              (Formulas.stat55to99Calc(stat) - Formulas.stat55to99Calc(stat - 1));
            return stat - 1 + fract;
          }
        }
      }
      return -1;
    }
  
    static thresholdCalc(tick) {
      return 1.0 - Math.pow(0.8251, 1.0 / tick);
    }
  
    static consistencyCalc(maxRawCritDamage, maxRawDamage, minRawDamage, mob) {
      const health = mobs[mob].hp;
      const defense = mobs[mob].hp;
      const totaldefense = health + defense;
  
      if (totaldefense - maxRawCritDamage > 0) {
        return 0;
      }
  
      const range = maxRawDamage - minRawDamage;
      const normaloneshots = maxRawDamage - totaldefense;
  
      if (normaloneshots > 0) {
        const normalconsistency = normaloneshots / range;
        return normalconsistency * 0.99 + 0.01;
      } else {
        const critrange = maxRawCritDamage - maxRawDamage;
        const criticaloneshots = maxRawCritDamage - totaldefense;
        return (criticaloneshots / critrange) * 0.01;
      }
    }
  }
  
  export default Formulas;